import React, { memo } from 'react';
import clsx from 'clsx';
import { MONTH_LABELS } from './constants';
import styles from './PeriodPicker.module.scss';

interface MonthGridProps {
  /** Zero-based, as dayjs `month()`. */
  value: number;
  onSelect: (month: number) => void;
}

const MonthGrid = ({ value, onSelect }: MonthGridProps) => {
  const handleMonthClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onSelect(Number(event.currentTarget.dataset.month));
  };

  return (
    <div className={styles.periodPicker}>
      <p className={styles.periodPickerTitle}>Pick a month</p>
      <div className={styles.monthGrid} role="group" aria-label="Months">
        {MONTH_LABELS.map((label, month) => (
          <button
            key={label}
            type="button"
            data-month={month}
            aria-pressed={month === value}
            className={clsx(styles.monthGridOption, { [styles.monthGridOptionSelected]: month === value })}
            onClick={handleMonthClick}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default memo(MonthGrid);
